// extracted by mini-css-extract-plugin
export default {"dropdown":"cIxRzA","button":"XXt5as","close":"yVKt9y"};